/* eslint-disable no-unused-vars */
export enum Status {
    PAGADO = 2,
    PENDIENTE = 1,
    CANCELADO = 3,
    ARREPENTIDO = 4
}
